import { Component, Input } from '@angular/core';

import { NgModel } from '@angular/forms';

@Component({
    selector: 'flo-invalid-warning',
    templateUrl: './invalid-warning.component.html',
})

export class InvalidWarningComponent {
    @Input() control: NgModel;
    @Input() message: string;
    @Input() isSubmitted: boolean;

    public displayValidationError(): boolean {
        return this.control &&
            !this.control.disabled &&
            !this.control.valid &&
            (!this.control.pristine || this.isSubmitted);
    }
}
